import { render, staticRenderFns } from "./DialogSuccess.vue?vue&type=template&id=21818aac&scoped=true"
import script from "./DialogSuccess.vue?vue&type=script&lang=js"
export * from "./DialogSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21818aac",
  null
  
)

export default component.exports